import { Button } from "@mgdx/ui/components/Button";
import { Checkbox } from "@mgdx/ui/components/Checkbox";
import { SubtleButton } from "@mgdx/ui/components/SubtleButton";
import { Text } from "@mgdx/ui/components/Text";
import { Title } from "@mgdx/ui/components/Title";
import { useState } from "react";

import { SubtleButtonAppExternalLink } from "../../ui/AppExternalLink/SubtleButtonAppExternalLink";

export type AgreementNewTermsConfirmViewProps = {
  isLoading?: boolean;
  onClickAgreement: VoidFunction;
  onClickShowReason: VoidFunction;
};

export const AgreementNewTermsConfirmView = ({
  isLoading,
  onClickAgreement,
  onClickShowReason,
}: AgreementNewTermsConfirmViewProps) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="p-4">
      <Title fontSize="xm" textAlign="center" as="h3">
        薬急便利用規約が変更されました
      </Title>

      <div className="mt-4 flex flex-col gap-4">
        <Text className="text-center">引き続きご利用になるには薬急便利用規約への再同意が必要です。</Text>

        <SubtleButtonAppExternalLink
          href={process.env.MGDX_YQB_ROOT_DOMAIN_URL + "/rules/terms/"}
          title="薬急便利用規約"
        >
          薬急便利用規約
        </SubtleButtonAppExternalLink>
      </div>

      <div className="flex flex-col items-center justify-center gap-2">
        <Checkbox align="center" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
          利用規約を確認しました
        </Checkbox>

        <Button disabled={!isChecked} loading={isLoading} onClick={onClickAgreement}>
          同意して利用する
        </Button>

        <SubtleButton onClick={onClickShowReason}>詳しい説明を見る</SubtleButton>
      </div>
    </div>
  );
};
